// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyAng9Vjiz-hXuPzmw0CUsCMen8b5fhCYio",
  authDomain: "brandverse-4365a.firebaseapp.com",
  projectId: "brandverse-4365a",
  storageBucket: "brandverse-4365a.appspot.com",
  messagingSenderId: "260530448861",
  appId: "1:260530448861:web:9f68b9783ecda25623ee34",
  measurementId: "G-5H5SMCLSKQ",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
